<era-pane>
  <era-devices-sync-modal [locationSubset]="locationSubset"
                          [userIsAdmin]="isAdmin$ | async"
                          (closeModal)="closeModal()"
                          (submitFilters)="syncDevices($event)">
  </era-devices-sync-modal>
</era-pane>